<template>
  <AuxoBanner
    :variant="props.success ? 'success' : 'error'"
    layout="short"
    :has-title="props.success"
    has-close-icon
    @close="$emit('close')"
  >
    <template v-if="props.success" #title>Your file is ready!</template>

    <template v-if="props.success">
      Your CSV file is ready to
      <span
        class="cursor-pointer font-bold underline"
        data-testid="export-toast-download"
        @click="
          () => {
            handleDownload(downloadUrl, fileName);
            $emit('close');
          }
        "
      >
        download
      </span>
    </template>

    <span v-else class="text-md text-error-700"
      >Export Failed: Please try again</span
    >
  </AuxoBanner>
</template>

<script setup>
import { handleDownload } from '@/utils/dom';
import AuxoBanner from '@/components/auxo/AuxoBanner.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value => ['success', 'error'].includes(value),
  },
  fileName: {
    type: String,
    required: true,
  },
  downloadUrl: {
    type: String,
    default: '',
  },
  success: {
    type: Boolean,
    default: true,
  },
});

defineEmits(['close']);
</script>
